import AuthenticatedResource  from 'resources/public/AuthenticatedResource';

// -----------------------------------------------------
// Resource Definition
// -----------------------------------------------------

export default class InvoiceResource extends AuthenticatedResource {
  static urlRoot = 'profile/:organization_slug/invoices';

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}